import gql from 'graphql-tag';

export default gql`
    query($currencyId: String) {
         getCurrencyById(currencyId: $currencyId) {
            currency
        }
    }
`;